var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-select',{attrs:{"id":"ethnicity","value":_vm.value,"name":"ethnicity","label":"Ethnicity","placeholder":"Any","placeholder-enabled":"","options":[
    { id: 'native', display_label: 'American Indian or Alaskan Native' },
    { id: 'asian', display_label: 'Asian' },
    { id: 'black', display_label: 'Black or African American' },
    { id: 'hispanic', display_label: 'Hispanic' },
    { id: 'multiracial', display_label: 'Multiracial' },
    { id: 'other', display_label: 'Other' },
    { id: 'pacific', display_label: 'Pacific' },
    { id: 'white', display_label: 'White' } ]},on:{"input":function (val) { return _vm.$emit('input', val); }}})}
var staticRenderFns = []

export { render, staticRenderFns }